import React from 'react';
import { Typography } from '@nextiva/next-ui-components';

export const COMPANY_SCHEDULES_TEXT = (
  <Typography variant="body1">
    <strong>Company schedules</strong>
    {
      ' are setup by an administrator and available to all users in the company. This is helpful when you want to establish a schedule that can be used by multiple people. You can even update this schedule for all users using it if your hours change.'
    }
  </Typography>
);

export const LOCATION_SCHEDULES_TEXT = (
  <Typography variant="body1">
    <strong>Location schedules</strong>
    {
      ' are setup by an administrator and available to all users in that location. This is helpful when you want to establish a schedule that can be used by multiple people within the same location.  You can even update this schedule for all users using it if your hours change. '
    }
  </Typography>
);

export const USER_SCHEDULES_TEXT = (
  <Typography variant="body1">
    <strong>User schedules</strong>
    {
      ' are personal and only available to that user. Personal schedules can be created to automatically enable features such as call forwarding, notifications, and much more.'
    }
  </Typography>
);
